export const isBotbRecord = (comp = {}) => {
  const opKey = String(comp?.operator_key || "").toLowerCase();
  const opName = String(comp?.operator?.name || comp?.operator_name || comp?.source_operator_name || "")
    .toLowerCase();
  const sourceUrl = String(comp?.source_competition_url || comp?.competition_url || "")
    .toLowerCase();
  return opKey === "botb" || opName === "botb" || sourceUrl.includes("botb.com");
};

export const isBotbSkillBased = (comp = {}) => {
  const family = String(comp?.botb_competition_family || comp?.botb_family_key || "")
    .toLowerCase();
  const mechanic = String(comp?.competition_mechanic || comp?.botb_mechanic || "")
    .toLowerCase();
  return isBotbRecord(comp) && (family === "skill_based" || mechanic === "spot_the_ball");
};

export const botbOddsUnavailableReason = (comp = {}, capReason = "") => {
  const explicit = String(comp?.odds_unavailable_reason || "").trim();
  if (/skill-based competition/i.test(explicit)) return "No standard odds available";
  if (/^max tickets not available$/i.test(explicit)) {
    return "Odds unavailable: max tickets not available";
  }
  if (/^ticket price not trusted$/i.test(explicit)) {
    return "Odds unavailable: ticket price not verified";
  }
  if (explicit) return explicit;
  const status = String(comp?.odds_model_status || "").toLowerCase();
  const family = String(comp?.botb_competition_family || comp?.botb_family_key || "")
    .toLowerCase();
  if (isBotbSkillBased(comp) || capReason === "botb_not_standard_odds_eligible") {
    return "No standard odds available";
  }
  if (status === "ticket_price_not_trusted") {
    return "Odds unavailable: ticket price not verified";
  }
  if (family === "unknown_safe" || status === "details_need_checking") {
    return "Details need checking";
  }
  return "Odds unavailable: max tickets not available";
};

export const botbDisplayDateFallback = (comp = {}) => {
  if (!isBotbRecord(comp)) return null;
  if (comp?.draw_date || comp?.closing_date || comp?.parsed_date) return null;
  return comp?.display_draw_date || "Check BOTB";
};
